// Mood Board Color
export const BG_PRIMARY = 'rgba(190,131,205,1)';
export const BG_SECONDARY = 'rgba(255,235,246,1)';

export const ASSETS_PRIMARY = 'rgba(200,49,135,1)';
export const ASSET_BORDER = 'rgba(200,49,135,1)';
export const ASSET_BG = 'rgba(199,157,208,1)';
export const BG_LAYER = 'rgba(248, 234, 231, 0.4)';

// Text Color
export const TEXT_PRIMARY = '#ffffff'; //brown dark
export const TEXT_SECONDARY = 'rgba(255,235,246,1)'; // Title color section
export const TEXT_ALTERNATIVE = 'rgba(200,49,135,1)'; // Button Text Color

// Music & Navigation Color
export const NAVIGATION_COLOR = ASSETS_PRIMARY; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
